import { DefaultBankCode } from 'enums';

export const BANKS_WITH_PAYMENT_LIMITS: string[] = [
  DefaultBankCode.Amobile,
  DefaultBankCode.Amra,
];
